import { memo, useContext } from 'react';
import { WWContext, type WWContextValue } from '../WWContext';
import ScheduleEvent from './ScheduleEvent';

import type { Gds_Event, Wws_Page, Wws_PageItem } from '../../types/graphql';
import InlineEditHandler from '../InlineEdit/InlineEditHandler/InlineEditHandler';
import { buildPageItemEditButton } from '../InlineEdit/InlineEditMessageFactory';

const buildEditEventContextMenuButtons = (
  page: Wws_Page,
  item: Wws_PageItem,
  event: Gds_Event
) => {
  return [buildPageItemEditButton(page, item, event.id)];
};

export interface EventGroupItemProps {
  page: Wws_Page;
  item: Wws_PageItem;
}

function EventGroupItem({ page, item }: EventGroupItemProps) {
  const { data } = useContext<WWContextValue>(WWContext);

  return data?.events?.map((event: Gds_Event, index: number) => (
    <InlineEditHandler
      key={event.id}
      contextMenuButtons={buildEditEventContextMenuButtons(page, item, event)}
    >
      <ScheduleEvent event={event} row={index} />
    </InlineEditHandler>
  ));
}

export default memo(EventGroupItem);
